import React from 'react';
import './style.scss';
import DocumentDescription from './shared/documentDescription';
import DocumentCards from './shared/documentCards';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';
import { withTranslation } from 'react-i18next';

const DocumentComponent = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="DocumentComponent" />;
  }

  const { items, heading, text, link } = props?.fields;
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;

  return (
    <div
      className={clsx(
        'content',
        'document-component',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        props?.params?.Styles
      )}
    >
      <DocumentDescription heading={heading} text={text} link={link} />
      <DocumentCards t={props?.t} lang={props?.i18n?.language} items={items} />
    </div>
  );
};
export default withTranslation()(DocumentComponent);
